/**
 * Temporary gating: allow ChatBot for dev/beta environments only.
 */
import { ENVIRONMENT } from '../../config';

export function isAllowedChatUser(email: string | null | undefined): boolean {
  console.log(ENVIRONMENT,"@@@@@@@@")
  const env = (ENVIRONMENT || '').toLowerCase();
  // return env === 'development' || env === 'beta';
  return env === 'production';
}
